import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { useService } from 'shared/providers';
import { Brands, ProductLookup } from 'shared/types';

export function useProductSearch(query: string, brand: Brands) {
  const { quoteService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const { data, isFetching, isLoading } = useQuery<Record<keyof ProductLookup, string>[], Error>(
    ['product', query],
    () =>
      quoteService
        .autoCompleteSearch<ProductLookup>({
          query,
          brand,
          searchColumn: 'concatenateditem',
          table: 'products',
        })
        .then(data => data.sort((one, two) => parseInt(two.transactioncount) - parseInt(one.transactioncount))),
    {
      initialData: [],
      enabled: Boolean(query),
      onError: error => {
        enqueueSnackbar(error.message, { variant: 'error' });
      },
    }
  );

  return { data, isFetching, isLoading } as const;
}
